import { createFileRoute } from '@tanstack/react-router'
import { Prontuario } from '@/features/prontuario/Prontuario'

/** Prontuário, a primeira aba da ficha. A chave fica na ficha. */
export const Route = createFileRoute('/_app/app/p/$id/')({
  component: function ProntuarioDoPaciente() {
    const { id } = Route.useParams()
    return <Prontuario patientId={id} />
  },
})
